<template>
    <div id="works">
        <div class="heading">
        Personal Projects
        </div>
        <p class="para">Here are some of the apps that I built/created during my leisure over the years</p>
        <div v-for="work in works" :key="work.name" @click="openModal(work)" class="list-item-container">
            <br/>
            <div class="list-item-content">
                <img class="round" :src="work.image" width="100px">
                <div class="work-item">
                    <div style="font-size:24px">{{work.name}}</div>
                    <div style="font-size:16px">{{work.desc}}</div>
                    <div v-if="work.info" style="font-size:16px">{{work.info}}</div>
                    <div v-if="work.lang" style="font-size:14px">
                        {{work.lang}} 
                        <span v-if="work.link"> | <a :href="work.link" target="_blank" rel="noopener noreferrer" @click.stop>{{work.link}}</a></span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div v-if="selectedWork" class="modal" @click="closeModal">
            <button class="close-btn-floating" @click="closeModal">&times;</button>
            <div class="modal-image-container">
                <div class="modern-gallery">
                    <img v-for="(img, idx) in projectImages" :key="idx" :src="img" class="modern-screenshot" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const projectAssets = require.context('@/assets', true, /\.(png|jpe?g|svg|webp|jfif)$/);

export default {
    name: 'Works',
    data() {
        return {
            selectedWork: null,
            works : [
                {
                    name : "Quads Launcher",
                    desc: "An android launcher inspired by the windows phone metro ui design.",
                    image: require('@/assets/ShanLogo.png'),
                    link: "https://github.com/BhuvaneshShan/Quads-launcher",
                    lang: "Android | Kotlin | Jetpack Compose",
                    info: "Developed a custom launcher for Android that implements a tile-based UI similar to the Windows Phone Metro interface. Focuses on customization and ease of access to apps.",
                    folder: null
                },
                {
                    name : "Nira",
                    desc: "A web app to re-imagine your vector images. Color your SVG (Scalable Vector Graphics) files and icons easily.",
                    image: require('@/assets/8_nira.png'),
                    link: "https://nira.design",
                    lang: "Vue | Javascript",
                    info: "Implememnted auto generation of different kinds of color palettes to quickly apply and check the look of SVG files. Created a system that can parse and apply colors to elements inspite of the svg file containing css styles.",
                    folder: 'nira'
                },
                {
                    name : "Bezie",
                    desc: "A web app to create vectors images quickly.",
                    image: require('@/assets/6_bezie.png'),
                    link: "https://bezie-app.com",
                    lang: "Vue | Typescript",
                    info: "Created an internal system that can store properties of different types of shapes and vectors along with their animatable attributes for interpolation and easing during runtime. This is as a single page application using Vue and typescript and utilizes web canvas for WYSIWYG editor. Implemented ways to export user's creation in jpeg, png and gif formats.",
                    folder: 'bezie'
                },
                {
                    name : "Mafia Companion - The Party Game Assistant",
                    desc: "An android app which assists in playing Mafia party game with friends in person",
                    image: require('@/assets/7_mafia_icon.png'),
                    link: "https://apkpure.com/mafia-companion-the-party-ga/com.bshan.daynight",
                    lang: "Android | Kotlin",
                    info: "This is a companion android app to play the famous party game - Mafia with friends in person. Helps with assinging roles for players and detailed rules.",
                    folder: 'mafia'
                },
                {
                    name : "PolygonArt",
                    desc: "An android app to create low poly art using polygons as brushes. 10,000+ downloads!",
                    image: require('@/assets/1_polygon_art.png'),
                    link: "https://apkpure.com/polygon-art/bhuva.polygonart",
                    lang: "Android | Java",
                    info: "Developed a grid based approach to find nearest set of vertices for a given point. Polygons were generated as a chain based on the preceding vertices.",
                    folder: 'polygonart'
                },
                {
                    name : "Easy pay",
                    desc: "An android experiment to simplify the process of mobile payment without taking smartphone out of one's pockets",
                    image: require('@/assets/4_easy_pay.png'),
                    link: "https://github.com/BhuvaneshShan/FinAppsParty",
                    lang: "Android | Java",
                    info: "Uses volume buttons and GPS to validate and proceed with payment",
                    folder: null
                },
                {
                    name : "Ghosts",
                    desc: "A pac-man like simulation where the user needs to code the AI for pac-man",
                    image: require('@/assets/2_pac_man.png'),
                    link: "https://github.com/BhuvaneshShan/Ghosts",
                    lang: "Processing",
                    info: "Created as a final level puzzle challenge for participants of a coding competition in undergrad.",
                    folder: 'ghosts'
                },
                {
                    name : "Lost in the Lost Temple",
                    desc: "A desktop adventure game with multiple levels and a level editor",
                    image: require('@/assets/3_lilt.png'),
                    link: "https://github.com/BhuvaneshShan/LostInTheLostTemple",
                    lang: "C++ | SDL",
                    info: "Designed and develped from scratch using Simple Directmedia Layer (SDL) library in C++. To quickly design levels, created a level editor that aids with placedment of objects and level visualization.",
                    folder: 'lilt'
                },
                {
                    name : "Misc Games",
                    desc: "Games such as snakes, Chutes and Ladders that I created during my undergrad days",
                    image: require('@/assets/5_misc_games.png'),
                    lang: "C++ | SDL",
                    folder: 'misc_games'
                },
            ]
        }
    },
    computed: {
        projectImages() {
            if (!this.selectedWork) return [];
            if (!this.selectedWork.folder) return [this.selectedWork.image];
            
            try {
                const folder = this.selectedWork.folder;
                return projectAssets.keys()
                    .filter(key => key.startsWith(`./${folder}/`))
                    .map(key => projectAssets(key));
            } catch (e) {
                return [this.selectedWork.image];
            }
        }
    },
    methods: {
        openModal(work) {
            this.selectedWork = work;
            document.body.style.overflow = 'hidden';
        },
        closeModal() {
            this.selectedWork = null;
            document.body.style.overflow = 'auto';
        }
    }
}
</script>

<style scoped>
.list-item-container {
    cursor: pointer;
    transition: background-color 0.2s;
    border-radius: 8px;
    padding: 10px;
}
.list-item-container:hover {
    background-color: var(--hover-bg);
}
.round {
     border-radius: 50%;
     float: left;
     border: 2px solid var(--hover-bg);
}
.work-item {
    margin-left: 120px;
    max-width: 700px;
}

/* Modal Styles */
.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: var(--modal-bg);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}

.close-btn-floating {
    position: fixed;
    top: 20px;
    right: 30px;
    background: rgba(255, 255, 255, 0.1);
    border: none;
    color: white;
    font-size: 40px;
    cursor: pointer;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.3s;
    z-index: 2100;
}

.close-btn-floating:hover {
    background: rgba(255, 255, 255, 0.2);
}

.modal-image-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    overflow-y: auto;
    padding: 60px 20px;
}

.modern-gallery {
    display: flex;
    flex-direction: column;
    gap: 40px;
    align-items: center;
    max-width: 1200px;
}

.modern-screenshot {
    max-width: 100%;
    max-height: 85vh;
    border-radius: 12px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
    object-fit: contain;
    background: #1a1a1a;
}

@media screen and (max-width: 600px) {
    .work-item {
        display: inline-block;
        margin-left: 0px;
    }
    .round {
        border-radius: 50%;
        display: inline-block;
        float: none;
    }
    .modern-screenshot {
        max-height: none;
    }
    .close-btn-floating {
        top: 10px;
        right: 10px;
        width: 45px;
        height: 45px;
        font-size: 30px;
    }
}
</style>